import AUomText from './index.vue';

AUomText.install = app => {
  app.component(AUomText.name, AUomText);
};

export default AUomText;
